import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';
import EmisorCustomization from './customization/EmisorCustomization';

class EmisoresCustomization extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: !!data.id ? { ...data, series: data.series || [] } : { id },
    };

    props.infoActions.reset();
  }

  async componentDidMount() {
    const { data } = this.state;

    if (!data.rfc) {
      this.props.history.replace('/app/emisores');
    }

    await this.props.infoActions.info(data.id, {
      include: 'series,config',
    });

    const { data: updated } = this.props.info;

    await this.props.customizationActions.setPartialState({
      data: updated,
    });
  }

  handleOnComplete = (data) => {
    this.props.customizationActions.setPartialState({
      data,
    });
  };

  render() {
    const { data = {}, busy } = this.props.info;

    if (busy || !data.rfc) {
      return <Loading />;
    }

    return (
      <>
        <PageHeader
          text="Regresar"
          to={`/app/emisores/${data.id}/info`}
        />

        <div>
          <EmisorCustomization
            data={data}
            onComplete={this.handleOnComplete}
          />
        </div>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    info: store.app.emisores.info,
    customization: store.app.emisores.customization,
  };
};

const mapActions = (actions) => {
  return {
    infoActions: actions.app.emisores.info,
    customizationActions: actions.app.emisores.customization,
  };
};

export default connect(useStore, mapState, mapActions)(EmisoresCustomization);
